import { useEffect, useState, forwardRef, ForwardedRef } from 'react'

import { ButtonRemoveFile } from '../ButtonRemoveFile'
import { File } from '../File'
import { FilledFileProps } from './interface'
import * as Styled from './styles'

const FilledFile = forwardRef<HTMLButtonElement, FilledFileProps>(
  (
    { file, removeFile, onRemoveFile }: FilledFileProps,
    ref: ForwardedRef<HTMLButtonElement>
  ): JSX.Element => {
    const [, setUploading] = useState(false)
    const [uploadProgress, setUploadProgress] = useState(0)
    const [fakeProgressInterval, setFakeProgressInterval] = useState<number>()

    const uploaded = uploadProgress > 100

    const startFakeUploadProgress = (): void => {
      const interval = window.setInterval(() => {
        setUploadProgress((currentProgress) => currentProgress + 1)
      }, 1)

      setFakeProgressInterval(interval)
    }

    useEffect(() => {
      if (file) {
        setUploading(true)
        setUploadProgress(0)
        startFakeUploadProgress()
      }
    }, [])

    useEffect(() => {
      if (uploaded) {
        setUploading(false)
        clearInterval(fakeProgressInterval)
      }
    }, [uploadProgress])

    return (
      <Styled.FileUpload>
        <Styled.FileUploadLeft uploaded={uploaded}>
          <File
            file={file}
            uploaded={uploaded}
            uploadProgress={uploadProgress}
          />
        </Styled.FileUploadLeft>

        <ButtonRemoveFile
          ref={ref}
          removeFile={removeFile}
          onRemoveFile={onRemoveFile}
        />
      </Styled.FileUpload>
    )
  }
)

FilledFile.displayName = 'FilledFile'

export { FilledFile }
